import toast from "react-hot-toast";
import useCreate from "../../useCreate";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import useGet from "../../useGet";

const useCreateEditUser = ({ isEdit = false, userId = null } = {}) => {
  const navigate = useNavigate();

  const {
    register,
    watch,
    handleSubmit,
    setValue,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      user_role: "",
      password: "",
      confirm_password: "",
      brand_id: "",
      brand_name: "",
    },
  });

  // For creating a user
  const { setDataToServer: createReq } = useCreate({
    url: "auth/create_admin",
    onSuccess: () => {
      // Handle success, e.g., show a success message or redirect
      toast.success("User created successfully");
      navigate("/masters/users");
    },
    onError: (error) => {
      // Handle error, e.g., show an error message
      toast.error(`Error creating user: ${error.message}`);
    },
  });

  const createUser = (data) => {
    createReq.mutate(data);
  };

  //   For fetching user data in edit mode
  const { data } = useGet({
    url: "auth/view_single_admin",
    enabled: !!userId,
    initialParams: {
      user_id: userId,
    },
    onSuccess: (data) => {
      const resData = data.data;
      setValue("first_name", resData.first_name);
      setValue("last_name", resData.last_name);
      setValue("email", resData.email);
      setValue("phone", resData.phone);
      setValue("user_role", resData.user_role);
      setValue("brand_id", resData.brand_id || "");
      setValue("brand_name", resData.brand_name || "");
    },
  });
  const isEditDataLoading = data.isLoading;

  const { setDataToServer: editReq } = useCreate({
    url: "auth/update_admin",
    onSuccess: () => {
      toast.success("User updated successfully");
    },
    onError: (error) => {
      toast.error(`Error updating user: ${error.message}`);
    },
  });

  const updateUser = (data) => {
    const updatedData = {
      user_id: userId,
      ...data,
    };

    delete updatedData.confirm_password;
    delete updatedData.password;

    editReq.mutate(updatedData);
  };

  return {
    createUser,
    updateUser,
    register,
    watch,
    handleSubmit,
    errors,
    isEditDataLoading,
    control,
    getValues,
    setValue,
  };
};

export default useCreateEditUser;
